import MemberList from '@/views/member/member-list.vue';
import MemberDetail from '@/views/member/member-detail.vue';

export default [{
		path: '/member-list',
		component: MemberList,
		name: 'memberList'
	},
	{
		path: '/member-detail',
		component: MemberDetail,
		name: 'MemberDetail'
	},
]
